import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { StaticRouter } from 'react-router-dom';
import reducer, { initialState } from './reducer';
import { StateProvider } from './StateProvider';
import 'bootstrap/dist/css/bootstrap.min.css';



ReactDOM.render(
  <React.StrictMode>
    {/* Using ContextProvider which makes reducer available in all components, below line means all components between stateprovider context will have access to / listen changes to initialState , reducer  */}

    <StateProvider initialState={initialState} reducer={reducer}>


      <App />

    </StateProvider>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
